import { jwtDecode } from "jwt-decode";
import { EntitlementType, ParsedEntitlements } from "../types/EntitlementTypes";

export const parseEntitlementsFromToken = (
  token: string,
): ParsedEntitlements => {
  try {
    const decoded = jwtDecode(token) as any;
    const claims = decoded?.["https://smartmerchandiser.com/jwt/claims"];
    const accountEntitlements = claims?.["account-entitlements"];

    if (!accountEntitlements) {
      return {
        raw: [],
        byAccount: new Map(),
        hasWildcardAccount: false,
      };
    }

    return parseEntitlementObject(accountEntitlements);
  } catch (error) {
    console.error("Error parsing entitlements from token:", error);
    return {
      raw: [],
      byAccount: new Map(),
      hasWildcardAccount: false,
    };
  }
};

export const parseEntitlementObject = (
  accountEntitlements: Record<string, string[]>,
): ParsedEntitlements => {
  const byAccount = new Map<string, Set<EntitlementType>>();
  let hasWildcardAccount = false;
  const rawEntitlements: string[] = [];

  Object.entries(accountEntitlements).forEach(([accountId, entitlements]) => {
    if (!Array.isArray(entitlements)) return;

    entitlements.forEach((e) => rawEntitlements.push(`${accountId}:${e}`));

    if (accountId === "*" && entitlements.includes("*")) {
      hasWildcardAccount = true;
    } else if (accountId !== "*") {
      const entitlementSet = new Set<EntitlementType>();
      entitlements.forEach((entitlement) => {
        entitlementSet.add(entitlement as EntitlementType);
      });
      byAccount.set(accountId, entitlementSet);
    }
  });

  return {
    raw: rawEntitlements,
    byAccount,
    hasWildcardAccount,
  };
};
